import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import Button from "components/button"
import { SwitchButton } from "components/switchButton"
import { TooltipParagraph } from "components/tooltipParagraph";
import { IOrgAccountItem } from "interfaces"
import moment from "moment";
import { Link } from "react-router-dom"
import { isHaveActionPermission } from "utills/helpers";

interface OrgAccountTableProps {
  data?: IOrgAccountItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const AccountTable = ({data = [], _toggleActive, currentPage, pageSize }: OrgAccountTableProps) => {
  return (
    <div className="flow-root">
      <div className="overflow-x-auto">
        <div className="relative inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
                >
                  No
                </th>
                <th scope="col" className="th">
                  Full Name
                </th>
                <th scope="col" className="th">
                  Email
                </th>
                <th scope="col" className="th">
                  Org name
                </th>
                <th scope="col" className="th">
                  Role name
                </th>
                <th scope="col" className="th">
                  Created at/by
                </th>
                <th scope="col" className="th">
                  Status
                </th>
                <th scope="col" className="th">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {data.map((account: IOrgAccountItem, index: number) => (
                <tr key={index}>
                  <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                    {(currentPage - 1) * pageSize + 1 + index}
                  </td>
                  <td className="td">{account.first_name} {account.last_name}</td>
                  <td className="td">{account.email}</td>
                  <td className="td max-w-40">
                    <TooltipParagraph 
                      text={account.organization_name}
                      className="whitespace-pre-wrap max-w-[280px]"
                    />
                  </td>
                  <td className="td">{account.role_name}</td>
                  <td className="td">
                    {moment(account.created).format("DD/MM/YYYY HH:mm:ss")} <br />
                    {account.created_by}
                  </td>
                  <td className="td">
                    <SwitchButton
                      checked={account.is_active}
                      disabled={
                        !isHaveActionPermission(
                          "account_management",
                          "organization",
                          "edit"
                        )
                      }
                      onChange={() =>
                        _toggleActive(account.id, account.is_active)
                      }
                    />
                  </td>
                  <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                    <div className="flex justify-end items-center gap-x-2">
                      <Link to={`/organization/accounts/${account.id}`} className="w-fit">
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <EyeIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                      {isHaveActionPermission(
                        "account_management",
                        "organization",
                        "edit"
                      ) ? (
                        <Link
                          to={`/organization/accounts/${account.id}/edit`}
                          className="w-fit"
                        >
                          <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                            <PencilIcon className="w-4 h-4 text-black" />
                          </Button>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}